var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataObj.labels && _vm.dataObj.series)?_c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"height":"350","options":_vm.chartOptions,"series":_vm.dataObj.series}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }